module.exports = __webpack_public_path__ + "static/media/arrow-white.f83fa94e.svg";